import React from "react"
import { observer } from "mobx-react-lite"

import useModal from "@components/modals/useModal"
import { ModalsTypes } from "@components/modals/constants"
import BaseModal from "@components/modals/components/BaseModal/BaseModal"
import ModalTitle from "@components/modals/components/ModalTitle/ModalTitle"
import config from "@root/config"

import styles from "./VideoPlayerModal.module.sass"

export interface VideoPlayerModalProps {
  /**
   * Key of a whitelisted public asset served by the backend
   * (GET /api/ts/assets/:assetKey). The video is streamed through the
   * App Service from a private storage account (no anonymous blob access).
   */
  assetKey: string
  title?: string
}

export const VideoPlayerModal: React.FC<VideoPlayerModalProps> = observer(
  ({ assetKey, title = "How to create a good prompt" }) => {
    const { hideModal } = useModal(ModalsTypes.VIDEO_PLAYER_MODAL)

    const videoUrl = `${config.API_ROOT}/api/ts/assets/${assetKey}`

    return (
      <BaseModal
        className={styles.root}
        title={<ModalTitle titleText={title} />}
        onClose={hideModal}
      >
        <div className={styles.videoWrapper}>
          {/* eslint-disable-next-line jsx-a11y/media-has-caption */}
          <video
            className={styles.video}
            src={videoUrl}
            controls
            autoPlay
            playsInline
          />
        </div>
      </BaseModal>
    )
  }
)

export default VideoPlayerModal
